class Employee {
  constructor(id, email, name, surname, slug, phone, bio, image, employeeOwner, employeeActive) {
    this.id = id;
    this.email = email;
    this.name = name;
    this.surname = surname;
    this.slug = slug;
    this.phone = phone;
    this.bio = bio;
    this.image = image;
    this.employeeOwner = employeeOwner;
    this.employeeActive = employeeActive;
  }
}

export default Employee;
